module.exports = __webpack_public_path__ + "img/kav_yes.77ab7f90.png";